import logo from "../../assets/Aish5X_logo_rgb.svg";

type Props = {
  height?: number;
};

export const Aish5XLogo = ({ height = 32 }: Props) => (
  <img
    src={logo}
    alt="Aish5X"
    style={{ height, width: "auto", display: "block" }}
  />
);